import { fade, makeStyles } from '@material-ui/core';

const HANDLE_POSITION = -24;

export const useSliderStyles = makeStyles(theme => ({
  rootWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    zIndex: 100,
  },
  root: {
    position: 'absolute', // Set this to absolute to prevent sizeme growth
    width: '100%',
    height: '100%',
    zIndex: 100,
    '&:hover $bodyHandle': {
      visibility: 'visible',
    },
  },
  horizontalRoot: {
    width: 'calc(100% - 94px)',
    left: '47px',
    display: 'flex',
    alignItems: 'center',
    '&::before, &::after': {
      zIndex: -2,
      position: 'absolute',
      top: 0,
      content: '""',
      backgroundColor: theme.palette.background.b7,
      width: 1,
      height: '100%',
    },
    '&::before': {
      left: 0,
    },
    '&::after': {
      right: 0,
    },
  },
  verticalRoot: {
    height: 'calc(100% - 40px)',
    top: 20,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '&::before, &::after': {
      zIndex: -2,
      position: 'absolute',
      left: 0,
      content: '""',
      backgroundColor: theme.palette.background.b7,
      width: '100%',
      height: 1,
    },
    '&::before': {
      top: 0,
    },
    '&::after': {
      bottom: 0,
    },
  },
  body: {
    position: 'relative',
    flex: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    userSelect: 'none',
    color: '#BDBDBD',
    border: `1px solid ${theme.palette.primary.text9}`,
    borderRadius: 4,
    '& svg': {
      fill: 'currentColor',
    },
    '&:hover': {
      cursor: 'grab',
      background: '#008BA366',
      color: '#FFFFFF',
    },
    '&:active': {
      cursor: 'grabbing',
      background: '#008BA366',
    },
    '&:active $bodyHandleIcon': {
      visibility: 'visible',
    },
    '&:hover $bodyHandleIcon': {
      visibility: 'visible',
    },
  },
  horizontalBodyHandle: {
    position: 'absolute',
    bottom: HANDLE_POSITION,
  },
  verticalBodyHandle: {
    position: 'absolute',
    left: HANDLE_POSITION,
    zIndex: 111,
  },
  leftBodyHandle: {
    position: 'absolute',
    left: HANDLE_POSITION,
    right: 'auto',
  },
  rightBodyHandle: {
    position: 'absolute',
    right: HANDLE_POSITION,
    left: 'auto',
  },
  topBodyHandle: {
    position: 'absolute',
    top: HANDLE_POSITION,
    bottom: 'auto',
  },
  bottomBodyHandle: {
    position: 'absolute',
    bottom: HANDLE_POSITION,
    top: 'auto',
  },
  bodyHandle: {
    // NOTE: bodyHandle should be always visible, not overflowed by inputs
    zIndex: 101,
    width: 24,
    height: 24,
    borderRadius: '50%',
    background: '#03BCD4',
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    visibility: 'hidden',
    '&:before': {
      position: 'absolute',
      left: '50%',
      top: '50%',
      height: 32,
      width: 24,
      content: '""',
      transform: 'translate(-50%, -50%)',
      zIndex: 1000,
    },
  },
  bodyHandleIcon: {
    visibility: 'hidden',
  },
  rootMinimal: {
    borderRadius: 4,
  },
  minimal: {
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    '&::before, &::after': {
      display: 'none',
    },

    '& $body': {
      '&:hover': {
        background: '#008BA366',
      },
      margin: -1,
      width: 'calc(100% + 2px)',
      height: 'calc(100% + 2px)',
      backgroundColor: fade(theme.palette.background.b7, 0.1),
      border: `1px solid ${theme.palette.primary.text9}`,
      borderRadius: 4,
    },
  },
  resizable: {
    backgroundColor: 'rgba(33,33,33,0.6)',
    zIndex: -1,
  },
  'horizontal-small': {
    height: 40,
  },
  'horizontal-medium': {
    height: 64,
  },
  'horizontal-large': {
    height: 120,
  },
  'vertical-small': {
    width: 40,
  },
  'vertical-medium': {
    width: 64,
  },
  'vertical-large': {
    width: 120,
  },
}));
